import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Retake: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.28 0.0155806C9.52867 0.132029 8.15138 0.484997 6.78629 1.16724C5.12563 1.99721 3.70795 3.23868 2.29541 5.1L2.004 5.484L1.99783 3.738L1.99169 1.992H0.995832H0V5.496V9H3.504H7.008V8.004V7.008H5.208C4.218 7.008 3.408 7.00129 3.408 6.99305C3.408 6.9463 4.06205 6.07964 4.43801 5.62822C4.79393 5.20085 5.59469 4.39162 5.95975 4.09035C7.55878 2.77078 9.37447 2.09583 11.5292 2.02006C12.0451 2.00192 12.7222 2.02061 13.0973 2.06336C15.0922 2.29076 16.9946 3.11664 18.504 4.41068C18.7669 4.63609 19.2931 5.15981 19.5342 5.436C21.0222 7.14084 21.8982 9.33663 21.9805 11.568L21.996 11.988L22.9973 11.9943L23.9985 12.0005L24.0077 12.2823C24.0127 12.4372 24.0124 12.3264 24.0071 12.036C23.9907 11.1476 23.9124 10.3578 23.7708 9.65384C23.1422 6.52769 21.3081 3.78713 18.6633 2.02222C16.6551 0.682037 14.3324 -0.0142994 11.9321 0.00420461C11.6328 0.00650861 11.3394 0.0116206 11.28 0.0155806ZM0.031224 12.582C0.080472 14.6446 0.793272 16.8218 2.02222 18.6633C3.66761 21.129 6.15458 22.8897 9.03425 23.6279C10.1164 23.9053 11.1332 24.0187 12.3 23.9921C13.6381 23.9616 14.7659 23.7714 15.8893 23.3867C18.1289 22.6198 19.945 21.2186 21.7046 18.9L21.996 18.516L22.0022 20.262L22.0083 22.008H23.0042H24V18.504V15H20.496H16.992V15.996V16.992H18.792C19.782 16.992 20.592 16.9987 20.592 17.007C20.592 17.0537 19.938 17.9204 19.562 18.3718C19.2061 18.7992 18.4053 19.6084 18.0402 19.9097C16.2313 21.4025 14.1146 22.0793 11.5655 21.9801C9.35443 21.894 7.18961 21.0413 5.496 19.5893C5.04593 19.2035 4.461 18.5867 4.07282 18.0886C2.86198 16.5348 2.08858 14.4247 2.02589 12.504C2.01878 12.2862 2.00803 12.0837 2.00203 12.054L1.99109 12H1.00421H0.017328L0.031224 12.582Z'
        fill={fill}
      />
    </svg>
  )
}

export default Retake
